import {Col, Row} from "reactstrap";
import {Label} from "@progress/kendo-react-labels";
import {
    aliasKey,
    assetInfoKey,
    cityKey,
    countryKey, hostMetaDataKey,
    mainMessages, notesKey,
    stateProvinceKey
} from "../../../../assets/text/MultilingualText";
import {Input, TextArea} from "@progress/kendo-react-inputs";
import React, {useContext} from "react";
import UserContext from "../../UserContext";
import {useLocalization} from "@progress/kendo-react-intl";
import {Text} from "../../MultilingualText";

export const HostInformation = (props) => {
    const {
        formValues,
        setFormValues,
    } = props
    const {
        siteLanguageDefault
    } = useContext(UserContext);
    const localization = useLocalization();

    const onChangeForm = (e) => {
        const name = e.target.element.name || e.target.name
        formValues[name] = e.value
        setFormValues({...formValues})
    }

    return (
        <>
            <Row className={"mt-4"}>
                <div
                    className={"k-h5"}
                >
                    <Text
                        textkey={hostMetaDataKey}
                        textdefault={mainMessages[siteLanguageDefault][hostMetaDataKey]}
                    />
                </div>
            </Row>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            <Label>
                                {localization.toLanguageString(aliasKey, mainMessages[siteLanguageDefault][aliasKey])}
                            </Label>
                            <Input
                                name={'alias'}
                                value={formValues.alias}
                                maxLength={50}
                                onChange={onChangeForm}
                            />
                        </Col>
                        <Col>
                            <Label>
                                {localization.toLanguageString(assetInfoKey, mainMessages[siteLanguageDefault][assetInfoKey])}
                            </Label>
                            <Input
                                name={'asset_info'}
                                value={formValues.asset_info}
                                maxLength={150}
                                onChange={onChangeForm}
                            />
                        </Col>
                    </Row>
                    <Row className='mt-2'>
                        <Col xs={6}>
                            <Label>
                                {localization.toLanguageString(cityKey, mainMessages[siteLanguageDefault][cityKey])}
                            </Label>
                            <Input
                                name={'city'}
                                value={formValues.city}
                                maxLength={50}
                                onChange={onChangeForm}
                            />
                        </Col>
                        <Col xs={3}>
                            <Label>
                                {localization.toLanguageString(stateProvinceKey, mainMessages[siteLanguageDefault][stateProvinceKey])}
                            </Label>
                            <Input
                                name={'state'}
                                value={formValues.state}
                                maxLength={50}
                                onChange={onChangeForm}
                            />
                        </Col>
                        <Col xs={3}>
                            <Label>
                                {localization.toLanguageString(countryKey, mainMessages[siteLanguageDefault][countryKey])}
                            </Label>
                            <Input
                                name={'country'}
                                value={formValues.country}
                                maxLength={50}
                                onChange={onChangeForm}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col className={"flex"}>
                    <div className={"flex flex-grow-1"}>
                        <Label>
                            {localization.toLanguageString(notesKey, mainMessages[siteLanguageDefault][notesKey])}
                        </Label>
                        <TextArea
                            name={'notes'}
                            className={"flex-grow-1"}
                            value={formValues.notes}
                            maxLength={500}
                            onChange={onChangeForm}
                            autoSize={false}
                        />
                    </div>
                </Col>
            </Row>
        </>
    )
}